import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { BlueprintGrid } from "../components/BlueprintGrid";
import { Link } from "react-router-dom";
import { fadeUp, fadeUpSlow, stagger, viewportOnce } from "../lib/motion";

const MaterialsClosing = () => (
    <section
        data-testid="materials-closing"
        className="relative overflow-hidden bg-ink py-28 lg:py-44"
    >
        <BlueprintGrid className="opacity-40" />
        <div className="relative mx-auto max-w-[1600px] px-6 md:px-10 lg:px-16">
            <motion.div
                variants={stagger}
                initial="hidden"
                whileInView="show"
                viewport={viewportOnce}
            >
                <motion.p
                    variants={fadeUp}
                    className="flex items-center gap-3 font-mono text-[13px] tracking-[0.3em] text-mist"
                >
                    <span className="h-1.5 w-1.5 bg-accent" />
                    THE BUILDEASE PRINCIPLE
                </motion.p>
                <motion.h2
                    variants={fadeUpSlow}
                    data-testid="materials-closing-headline"
                    className="mt-10 max-w-5xl font-display text-4xl font-semibold leading-[1.12] text-white md:text-6xl lg:text-7xl"
                >
                    <span className="text-accent">“</span>If we can't verify it,
                    we don't pretend to know it.
                    <span className="text-accent">”</span>
                </motion.h2>
                <motion.div variants={fadeUp} className="mt-14">
                    <Link
                        to="/join-the-pilot"
                        data-testid="materials-join-pilot"
                        className="inline-flex items-center gap-3 bg-accent px-8 py-4 text-[16px] font-semibold tracking-wide text-white transition-colors duration-300 hover:bg-[#ff7026]"
                    >
                        Join the Pilot
                        <ArrowUpRight className="h-4 w-4" />
                    </Link>
                </motion.div>
            </motion.div>
        </div>
    </section>
);

export default MaterialsClosing;
